<div>
  <h1 class="header col-12 mb-2">
    Annuity Book Management <span>- Office View</span>
  </h1>

  <app-bm-widget-filters [viewMode]="'ho'" />

  <div class="home-office-container">
    <div class="row">
      <app-contract-stats
        class="col-12"
        [reportName]="'PM Unit Contract Totals'"
      />
    </div>

    <div class="row">
      <app-contract-summary
        class="col-12"
        [reportName]="'PM Unit Contract Summary'"
        [headerType]="'unit'"
      />
    </div>

    <div class="row">
      @if (showPolicyReview) {
        <app-top-policy-review
          class="col-12"
          [title]="'Policy Review Relevance'"
          [configType]="'unit-top-policy-review'"
          [reportName]="'PM Unit Top Policy Review'"
        />
      }
    </div>

    <div class="row">
      <app-top-performers
        class="col-12"
        [title]="'Top Performers'"
        [configType]="'unit-top-performers'"
        [reportName]="'PM Unit Top Performers'"
      />
    </div>

    <div class="row">
      @if (showPolicyTags) {
        <app-policy-alerts
          class="col-12"
          [configType]="'unit-policy-alerts'"
          [reportName]="'PM Unit Policy Alerts'"
          [headerType]="'unit'"
        />
      }
    </div>
  </div>
</div>
